import { isBackend } from "./detectBackend";
var rejectNetwork = function (url) { return url.indexOf('http') !== 0; };
export var settings = {
    hot: (!!module).hot,
    SSR: isBackend,
    rethrowErrors: process.env.NODE_ENV !== 'production',
    fileFilter: rejectNetwork,
    updateOnReload: false,
};
export var setConfiguration = function (config) {
    Object.assign(settings, config);
};
